// @flow
import { useCallback, useContext, useState } from 'react';
import { stylesheet } from 'typestyle';

import ShippingInfo from '@components/productDetail/ShippingInfo';
import AddToShoppingBagButton from '@components/productDetail/bands/AddToShoppingBagButton';
import RingSizeSelector from '@components/productDetail/bands/RingSizeSelector';
import BackToSearchLink from '@components/productDetail/BackToSearchLink';

import { detailPath } from '@src/app_routes/bands';

import { SkuContext } from '@contexts/sku';

import useProductDetailColumnCount from '@hooks/useProductDetailColumnCount';

import css from '@styles/productDetail';

import * as routes from '@src/app_routes/bands';
import { replaceState } from '../../../utils/replaceState';

import type { TBandDetail } from '@types/band';

type TProps = {
  band: TBandDetail
};

const localCss = stylesheet({
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',

    '@media (min-width: 471px) and (max-width: 679px)': {
      marginLeft: 'auto'
    },

    '@media (min-width: 831px) and (max-width: 1009px)': {
      marginLeft: 'auto'
    }
  }
});

function Actions({ band }: { band: TBandDetail }) {
  const { setSku } = useContext(SkuContext);
  const [ringSize, setRingSize] = useState(null);
  const handleSizeChange = useCallback(
    newSize => {
      if (+newSize[0]) {
        setRingSize(newSize[0]);
        setSku(newSize[1]);
        if (window) {
          replaceState(
            {},
            '',
            detailPath({
              vendor_sku: newSize[1],
              url_segment_description: newSize[2]
            })
          );
        }
      } else {
        setRingSize(null);
      }
    },
    [setSku]
  );

  if (!band) return null;

  return (
    <div className={css.actionsContainer}>
      <RingSizeSelector onChange={handleSizeChange} />
      <div className={localCss.buttonsContainer}>
        <AddToShoppingBagButton ringSize={ringSize} />
        <BackToSearchLink url={routes.searchPath()} />
      </div>
    </div>
  );
}

export default function ShippingAndActions({ band }: { band: TBandDetail }) {
  const columnCount = useProductDetailColumnCount();

  if (!band) return null;

  return (
    <div className={css.shippingAndActions}>
      {columnCount > 1 ? (
        <ShippingInfo deliveryDate={band.delivery_date} borders={false} />
      ) : null}
      <Actions band={band} />
    </div>
  );
}
